<template>
  <input type="color" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
</template>

<script>
export default {
  name: 'Verte',
  props: {
    modelValue: { type: String, default: '#000000' }
  },
  emits: ['update:modelValue']
}
</script>
